import {ChipField, Datagrid, EditButton, List, TextField} from 'react-admin';


const ListNft = props => {
  return (
    <List {...props}>
      <Datagrid>
        <ChipField source="id" />
        <TextField source="name" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
export default ListNft;